<mat-form-field #formFieldContainer class="phone-number-class">
  <mat-label
    #labelContainer (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>
  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>

  <input matInput placeholder="{{ componentDefinition?.label }}"
         type="tel"
         [id]="componentDefinition?.name"
         [name]="componentDefinition?.name"
         maxlength="20"
         (keydown)="validatePhoneNumber($event)"
         (paste) ="cleanPastedValue($event)"
         [formControl]="formControl"
  />

  <a mat-icon-button matSuffix *ngIf="fieldValue" [href]="'tel:'+fieldValue" [title]="'tel:'+fieldValue">
    <mat-icon color="primary">phone</mat-icon>
  </a>
</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
